var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #153657;\n        opacity: 0.3;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_9023",
    "data-name": "Gruppe 9023",
    transform: "translate(-82 -307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3250",
    "data-name": "Pfad 3250",
    className: "cls-1",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(82 307)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_8222",
    "data-name": "Gruppe 8222",
    transform: "translate(93.647 315.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6268",
    "data-name": "Gruppe 6268",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6267",
    "data-name": "Gruppe 6267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2524",
    "data-name": "Pfad 2524",
    className: "cls-2",
    d: "M240.318,299.951a1.64,1.64,0,0,0,0,3.28,1.64,1.64,0,1,0,0-3.28Z",
    transform: "translate(-236.399 -287.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2525",
    "data-name": "Pfad 2525",
    className: "cls-2",
    d: "M223.925,197.548c-2.875,0-4.2,1.7-4.2,2.854a1.221,1.221,0,0,0,1.278,1.214c1.15,0,.681-1.64,2.854-1.64,1.065,0,1.917.468,1.917,1.448,0,1.15-1.193,1.81-1.9,2.407a3.9,3.9,0,0,0-1.427,3.237c0,1.107.3,1.427,1.171,1.427,1.044,0,1.256-.469,1.256-.873a2.674,2.674,0,0,1,1.193-2.662c.575-.447,2.385-1.9,2.385-3.9S226.651,197.548,223.925,197.548Z",
    transform: "translate(-219.73 -197.548)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.3d095fd18dc5eaa3b20e36565a75ce2e.svg";
export { ForwardRef as ReactComponent };